module.exports = __webpack_public_path__ + "img/sdg_icon_04.e9cdfd67.png";